import { useEffect, useState, useCallback } from 'react';
import { useHexStyles } from '../../../hooks/useHexStyles';
import { usePreview } from '../../DndPreview';
import getFocusPreviewCoords from '../../../services/getFocusPreviewCoords';

export default function GamePiecePreview({
  board,
  gridItemProps,
  selectedPiece,
  gameboardRef,
}) {
  let { display, item, style } = usePreview({
    options: {
      offsetX: +gridItemProps.preview?.dragOffset?.x,
      offsetY: +gridItemProps.preview?.dragOffset?.y,
    },
  });

  let hex = item !== undefined && !!item.data ? item.data : false;

  const calculateFocusTransform = useCallback(
    (target) => {
      if (!target) {
        target =
          document.activeElement?.tagName === 'BUTTON'
            ? document.activeElement
            : document.activeElement?.querySelector('BUTTON');
      }
      const currentOffset = getFocusPreviewCoords(target, {
        offsetX: +gridItemProps.preview?.keyboardDragOffset?.x,
        offsetY: +gridItemProps.preview?.keyboardDragOffset?.y,
      });
      // console.log('calculateFocusTransform', target, currentOffset);
      return `translate(${currentOffset.x}px, ${currentOffset.y}px)`;
    },
    [gridItemProps.preview]
  );

  const [keyboardStyle, setKeyboardStyle] = useState(() => ({
    pointerEvents: 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 4,
    transform: calculateFocusTransform(),
  }));

  if (display) {
    hex = item.data;
  } else if (
    !display &&
    selectedPiece &&
    gameboardRef.current?.contains(document.activeElement)
  ) {
    hex = selectedPiece;
    style = keyboardStyle;
  }

  const hexStyles = useHexStyles({ hex, gridItemProps, board });

  useEffect(() => {
    // if (!gameboardRef.current) return;
    console.log('calculating keyboard style');
    const calculateFocusStyles = () => {
      const transform = calculateFocusTransform();
      setKeyboardStyle({
        pointerEvents: 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 100,
        transform,
        WebkitTransform: transform,
      });
    };

    // TODO: add listener to gameboardRef.current instead of all body
    document.body.addEventListener('click', calculateFocusStyles);
    document.body.addEventListener('keyup', calculateFocusStyles);
    return () => {
      document.body.removeEventListener('click', calculateFocusStyles);
      document.body.removeEventListener('keyup', calculateFocusStyles);
    };
  }, [calculateFocusTransform]);

  if (!hex) {
    return null;
  }

  // console.log('GamePiecePreview', {display, item, style, hex, selectedPiece });

  style = {
    ...hexStyles,
    ...style,
    zIndex: 100,
  };

  return <div className="GamePiece GamePiece--Preview" style={style}></div>;
}
